<i [ngClass]="iconClass"></i>